import axios from './_nestAxios'

export const descargarReporteProduccion = params =>
  axios.get('/kardex/descargar/produccion', { responseType: 'blob', params })

export const getReporteGeneralStock = data =>
  axios.get('/kardex/descargar/general-stock', { responseType: 'blob', params: data })

export const getReporteFormato12_1 = data =>
  axios.get('/kardex/descargar/formato-12-1', { responseType: 'blob', params: data })

export const getReportePorProducto = idProducto =>
  axios.get('/kardex/por-producto', { params: { idProducto: idProducto } })

export const obtenerKardexIngresoAlmacenSinUsar = idSocio =>
  axios.get('/kardex/ingreso-almacen', { params: { idSocio: idSocio } })

export const obtenerDetallesParaCompraGuias = idsSeleccionados =>
  axios.get('/kardex', { params: { idsKardex: idsSeleccionados, tipoConsulta: 'compras-guias' } })

export const descargarExcelConsultaConsumos = data =>
  axios.get(`/kardex/consultas/descargar`, { params: data, responseType: 'blob' })

export const descargarReporteEntradasSalidas = data =>
  axios.get(`/kardex/descargar/entradas-salidas`, { params: data, responseType: 'blob' })

export const getSiguienteNumeroxSeriexTipoDocumento = ({ serie, tipoDocumento, tipoOperacion }) =>
  axios.get(`/kardex/siguiente-numero`, { params: { serie, tipoDocumento, tipoOperacion } })

export const obtenerxIdAsEdicion = id => axios.get(`/kardex/${id}`, { params: { tipoConsulta: 'se' } })
export const obtenerxIdAsSoloLectura = id => axios.get(`/kardex/${id}`, { params: { tipoConsulta: 'solo-lectura' } })
export const obtenerxIdAsDetallesTaller = id =>
  axios.get(`/kardex/${id}`, { params: { tipoConsulta: 'detalles-taller' } })
export const obtenerDetalleIngresoAlmacen = id =>
  axios.get(`/kardex/${id}`, { params: { tipoConsulta: 'detalle-ingreso-almacen' } })
export const descargarxId = id => axios.get(`/kardex/${id}/descargarSalidaAlmacen`, { responseType: 'blob' })
export const descargarHojaEntregaxId = id => axios.get(`/kardex/${id}/descargarHojaEntrega`, { responseType: 'blob' })

export const nuevo = data =>
  axios.post('/kardex/es-inventarios', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
export const actualizar = (id, data) =>
  axios.put(`/kardex/es-inventarios/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })


export const listarAdjuntos = (id) =>
  axios.get(`/kardex/adjuntos/lista/${id}`);

export const descargarAdjunto = (idAdjunto, config = {}) =>
  axios.get(`/kardex/adjuntos/descargar/${idAdjunto}`, {
    ...config,
    responseType: config.responseType || 'blob'
  });


export const nuevoIngresoAlmacenPorOrdenCompra = data => axios.post('/kardex/ingreso-almacen-orden-compra', data)

export const eliminarxId = id => axios.delete(`/kardex/${id}`)
export const descargarReporteFormato3_7 = params =>
  axios.get('/kardex/descargar/formato-3-7', { responseType: 'blob', params })
export const descargarReportexTipoOperacion = params =>
  axios.get('/kardex/descargar/reporte-bajo-tipo-movimiento', { responseType: 'blob', params })
export const recalcularStocks = () => axios.post('/kardex/recalcular-stocks')

export const descargarReporteFormato13_1 = params =>
  axios.get('/kardex/descargar/formato-13-1', { responseType: 'blob', params })
export const valorizarTodo = (mes) => axios.post('/kardex/valorizar-todo', { mes: mes }, { responseType: 'blob' })
export const recalcularCostoTodo = () => axios.post('/kardex/recalcular-costo')
export const obtenerSaldosAnoPasado = (data) => axios.post('/kardex/obtener-saldos-ano-pasado', data)
export const getConsultaxIdProducto = idProducto =>
  axios.get('/kardex/consulta-por-producto', { params: { idProducto: idProducto } })

export const descargaPlantillaSaldosIniciales = () =>
  axios.get('/kardex/descargar/plantilla-saldos-iniciales', {
    responseType: 'blob'
  })

export const obtenerxIdOrdenCompraAsInfoDetalle = idOrdenCompra =>
  axios.get(`/kardex/orden-compra/${idOrdenCompra}`, {
    params: {
      tipoConsulta: 'info-detalle'
    }
  })

export const obtenerInfoCostosxIdProducto = idProducto =>
  axios.get(`/kardex/costo-reposicion-promedio`, { params: { idProducto } })

export const obtenerConsultaConsumosAsTable = data => axios.get(`/kardex/consultas-consumos`, { params: data })

export const obtenerConsultaKardexAsTable = data => axios.get('/kardex/consultas-kardex', { params: data })

export const obtenerKardexDetallexIdAsConsultaModalTable = id => axios.get(`/kardex/consultas/${id}`)

export const obtenerDetallexIdProductoAsConsultaModalTable = data =>
  axios.get(`/kardex/consultas-consumos/detalles`, { params: data })

export const importarPlantillaSaldosIniciales = data => axios.post('/kardex/importar-plantilla-saldos-iniciales', data)

// Consulta JSON para reportes (Buscar)
export const consultaGeneralStock = () => axios.get('/kardex/consulta/general-stock')
export const consultaFormato3p7 = params => axios.get('/kardex/consulta/formato-3-7', { params })
export const consultaProduccion = params => axios.get('/kardex/consulta/produccion', { params })
export const consultaEntradasSalidas = params => axios.get('/kardex/consulta/entradas-salidas', { params })
export const consultaTipoOperacion = params => axios.get('/kardex/consulta/tipo-operacion', { params })
export const consultaFormato12p1 = params => axios.get('/kardex/consulta/formato-12-1', { params })
export const consultaFormato13p1 = params => axios.get('/kardex/consulta/formato-13-1', { params })
